module.exports = __webpack_public_path__ + "media/images/illustrations/trash_can_large-962c71c0b29fb183a24f84c2360bed00.svg";